<template>
  <div class="data_brain_wrap">
	<div class="enter_title_wrap">
		<div class="enter_inner">
		<div class="inner_left">
			<img src="../../assets/img/tupianright.png" alt="" />
		</div>
		<div class="inner_center">
			<div class="enter_title">关于亿微</div>
			<div class="enter_desc"></div>
		</div>
		<div class="inner_right">
			<img src="../../assets/img/tupianleft.png" alt="" />
		</div>
		</div>
	</div>
	<div class="mall_wrap">
	  <div class="mall_img" data-aos="fade-up">
	    <img src="@/assets/img/home_profile.jpg" alt="" />
	  </div>
	  <div class="mall_details" data-aos="fade-up">
		  <!-- 这里使用后端接口数据，方便更新维护-->
		<p v-html="company_profile"></p>
<!-- 	    <p>
	      福安亿微电子科技有限公司成立于2015年，是一家科技型企业，位于福建省宁德市王基岭工业区665号，主要从事电子控制类软硬件电子产品研发、生产和销售，承接电子电路板OED,ODM订单。是一家着力于电子智能控制的科技公司
	    </p> -->
	    <div class="mall_btn">
	      <el-button class="btn_self" @click="gotoDetails">了解更多</el-button>
	    </div>
	  </div>
	</div>
	<div class="enter_title_wrap">
		<div class="enter_inner">
		<div class="inner_left">
			<img src="../../assets/img/tupianright.png" alt="" />
		</div>
		<div class="inner_center">
			<div class="enter_title">产品中心</div>
			<div class="enter_desc"></div>
		</div>
		<div class="inner_right">
			<img src="../../assets/img/tupianleft.png" alt="" />
		</div>
		</div>
	</div>
    <el-row class="card_wrap" type="flex">
      <el-col
        class="brain_item"
        :lg="7"
        :sm="11"
        :xs="11"
        v-for="(item, index) in cardList"
        :key="index"
      >
        <div class="item_title" data-aos="fade-up">{{ item.title }}</div>
        <div class="item_desc" data-aos="fade-up">{{ item.desc }}</div>
		<el-button class="item_navigate" @click="handleNavigate">了解详情 >></el-button>
        <div class="item_bg">
			<img :src="item.bg_img" alt="" />
		</div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
	  company_profile: '',
      cardList: [
        {
          title: '按摩椅控制板',
          desc: '按摩椅控制主板是按摩椅的大脑，它负责接收手控器的命令，控制按摩椅的程序、电机运作及电源的载体，发出指令给按摩椅的按摩系统，使机械手根据指令沿着导轨工作，实现各种按摩手法和效果。',
          bg_img: require('@/assets/img/product/kzb1.jpg'),
		},
        {
          title: '旋钮按键手控',
          desc: '按摩椅旋钮手控是一种简单的按摩椅控制器，它可以通过旋转不同的旋钮来选择按摩椅的功能和模式。该电路板通常搭配按键和指示灯辅助选择和控制按摩椅各项功能。',
		  bg_img: require('@/assets/img/product/xnajsk1.jpg'),
		},
        {
          title: '电源板',
          desc: '按摩椅电源控制板是按摩椅的重要组成部分之一，它负责将外部的交流电转换为按摩椅所需的直流电，并对电源进行稳压、过滤、保护等处理，以保证按摩椅的正常工作。',
          bg_img: require('@/assets/img/product/dyb1.jpg'),
		},
        {
          title: '按摩椅按键手控',
          desc: '按摩椅按键手控是一种常见的按摩椅控制器，它可以通过按下不同的按键来选择按摩椅的功能和模式。按摩椅按键手控是一种常见的按摩椅控制器，它可以通过按下不同的按键来选择按摩椅的功能和模式。',
          bg_img: require('@/assets/img/product/ajsk1.jpg'),
		},
        {
          title: '蓝牙控制板',
          desc: '按摩椅蓝牙控制板的功能是可以通过蓝牙连接手机或其他智能设备，实现对按摩椅的远程控制，例如选择按摩程序、调节按摩力度、播放音乐等。例如选择按摩程序、调节按摩力度、播放音乐等。',
          bg_img: require('@/assets/img/product/lykzb1.jpg'),
		},
        {
          title: '亿微上位机软件',
          desc: '亿微拥有自己独立研发的上位机软件，可以用于按摩时序录制、导出、下载，可以通过它进行按摩椅硬件调试，按摩模式流程模拟等操作。更多功能可根据客户需求定制开发。',
          bg_img: require('@/assets/img/product/swj1.jpg'),
		},
      ],
    }
  },
  created() {
  	  this.getCompanyProfile();
  },
  methods:{
    handleNavigate(){
      this.$router.push('/profiles').catch((v) => {})
    },
	gotoDetails(){
      this.$router.push('/profiles').catch((v) => {})
    },
    async getCompanyProfile() {
      const res = await this.axios.get(
        '/api/profile/list'
      )
    	this.company_profile = res.data.data[0]["content"];
    },
  }
}
</script>

<style lang="scss" scoped>
.data_brain_wrap {
  padding: 50px 0;
  background: #e8eef2;
  text-align: center;
  .brain_title {
    color: #203040;
    font-size: 35px;
    font-weight: bold;
    padding: 30px 0;
    @media screen and (max-width: 768px) {
      font-size: 1.5rem;
    }
  }
  .brain_desc {
    // padding: 10px 400px;
    color: rgba(32, 48, 64, 0.75);
    font-size: 22px;
    letter-spacing: 4px;
    @media screen and (max-width: 768px) {
      font-size: 0.8rem;
      line-height: 40PX;
    }
  }
  .enter_title_wrap {
    width: 100%;
    margin-top: 100px;
    @media screen and (max-width: 768px) {
      margin-top: 30px;
    }
    .enter_inner {
      display: flex;
      justify-content: center;
      .inner_left {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        @media screen and (max-width: 768px) {
          flex: 1;
        }
        img {
          width: 30%;
        }
      }
      .inner_center {
        width: 400px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 0 50px;
        @media screen and (max-width: 768px) {
          flex: 2.2;
        }
        .enter_title {
          font-size: 40px;
          font-weight: bold;
          @media screen and (max-width: 768px) {
            font-size: 1rem;
          }
        }
        .enter_desc {
          font-size: 16px;
          color: #787878;
          margin-top: 10px;
          @media screen and (max-width: 768px) {
            margin-top: 10px;
          }
        }
      }
      .inner_right {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        @media screen and (max-width: 768px) {
          flex: 1;
        }
        img {
          width: 30%;
        }
      }
    }
  }
  .mall_wrap {
	  width: 70%;
	  display: flex;
	  justify-content: center;
	  margin: 34px auto;
	  @media screen and (max-width: 768px) {
		width: 90%;
	  }
	  @media screen and (max-width: 768px) {
		flex-direction: column;
	  }
	  .mall_img {
		width: 50%;
		margin-right: 30px;
		padding: 0 30px;
		@media screen and (max-width: 768px) {
		  width: 100%;
		}
		img {
		  width: 100%;
		}
	  }
	}
    .mall_details {
      width: 50%;
      display: flex;
	  text-align: left;
	  text-indent: 40px;
      flex-direction: column;
      justify-content: center;
      @media screen and (max-width: 768px) {
        width: 95%;
		margin-top: 25px;
		padding-left: 5%;
        text-align: center;
      }
      p {
        font-size: 20px;
        @media screen and (max-width: 768px) {
          font-size: 14px;
        }
      }
      .mall_btn {
        margin-top: 40px;
        @media screen and (max-width: 768px) {
          padding: 20px 0;
        }
        .btn_self {
          background: #3099dd;
          color: #fff;
          border-radius: 20px;
          border: none;
          @media screen and (max-width: 768px) {
            width: 80px;
            height: 35px;
            border-radius: 20px;
            font-size: 14px;
          }
        }
      }
   }
  .card_wrap {
    width: 70%;
    flex-wrap: wrap;
    margin: 0px auto;
    justify-content: space-around;
    @media screen and (max-width: 768px) {
      width: 95%;
    }
    .brain_item {
      transition: background-color 1s;
      padding: 30px;
      @media screen and (max-width: 768px) {
        font-size: 0.8rem;
        line-height: 40PX;
        // border-radius: 10PX;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        margin-top: 20PX;
        &:nth-child(-n+2){
          margin-top: 0;
        }
      }
      background: #fff;
      // border-radius: 20px;
      box-shadow: 0 0.5rem 1.5rem 0 rgba(0, 135, 168, 0.15);
      margin-top: 40px;
      position: relative;
      .item_bg {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(
          134deg,
          #0649b8 1%,
          #0a7fd7 41%,
          #03d2c5 99%
        );
        opacity: 0;
        transition: all 0.5s;
        // border-radius: 20px;
        z-index: 1;
		img {
			position: absolute;
			width: 100%;
			height: 50%;
			opacity: 0.1;
			left: 0;
			right: 0;
			bottom: 0;
		}
      }
	/* 奇数项（基数）默认样式 */
	  &:nth-child(odd) {
		.item_bg {
		  opacity: 0;
		}
		.item_title {
		  color: #203040;
		}
		.item_desc {
		  color: #666;
		}
		&:hover {
		  .item_bg {
			opacity: 1;
		  }
		  .item_title,
		  .item_desc {
			color: #fff !important;
		  }
		}
	  }

	  /* 偶数项默认样式 */
	  &:nth-child(even) {
		.item_bg {
		  opacity: 1;
		}
		.item_title {
		  color: #fff;
		}
		.item_desc {
		  color: rgba(255, 255, 255, 0.8);
		}
		&:hover {
		  .item_bg {
			opacity: 0;
		  }
		  .item_title {
			color: #203040 !important;
		  }
		  .item_desc {
			color: #666 !important;
		  }
		}
	  }
      .item_title {
        transition: all 0.5s;
        font-size: 30px;
        font-weight: bold;
        color: #203040;
        text-align: left;
        padding: 20px 0 40px 0;
        z-index: 2;
        position: inherit;
        @media screen and (max-width: 768px) {
          font-size: 1rem;
          text-align: center;
        }
      }
      .item_desc {
        transition: all 0.5s;
        color: #666;
        text-align: left;
        line-height: 1.5rem;
        z-index: 2;
        position: inherit;
        font-size: 18px;
        min-height: 110px;
        @media screen and (max-width: 768px) {
          min-height: 110PX;
          text-indent: 2em;
          font-size: 12px;
        }
      }
      .item_navigate {
        background-color: #2f82ff;
		border-color: #2f82ff;
        color: #fff;
        border-radius: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        margin-top: 40px;
        cursor: pointer;
        z-index: 2;
        position: inherit;
        @media screen and (max-width: 768px) {
          margin-bottom: 10PX;
          font-size: 14px;
        }
      }
    }
  }
}
</style>
<style lang="css">
  .ql-indent-1 {
    padding-left: 0px !important;
    text-indent: 1em !important;
  }
  
  .ql-indent-2 {
  	padding-left: 0px !important;
  	text-indent: 2em !important;
  }
  
  .ql-indent-3 {
  	padding-left: 0px !important;
  	text-indent: 3em !important;
  }
  
  .ql-indent-4 {
  	padding-left: 0px !important;
  	text-indent: 4em !important;
  }
  
  .ql-indent-5 {
  	padding-left: 0px !important;
  	text-indent: 5em !important;
  }
  
  .ql-indent-6 {
  	padding-left: 0px !important;
  	text-indent: 6em !important;
  }
  
  .ql-indent-7 {
  	padding-left: 0px !important;
  	text-indent: 7em !important;
  }
  
  .ql-indent-8 {
  	padding-left: 0px !important;
  	text-indent: 8em !important;
  }
  
  .ql-align-center {
    text-align: center;
  }
</style>